import React, { useState, useEffect, useContext } from "react";

// import { getStatus } from '../../../utils/Compras/Consultas_Requisicion';



import RequisicionCompraModal from "./CrudRequisa/RequisaComprasModalCrud";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { Dialog } from "primereact/dialog";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";

const ListadoRequisaTab = ({ listadoRequisas, loading }) => {
    const { userAuth } = useContext(AuthContext);

    const [estados, setEstados] = useState([]);

    const [purchaseShow, setPurchaseShow] = useState(false);
    const [requisaDialog, setRequisaDialog] = useState(false);



    const columns = [
        {
            header: 'ID',
            field: 'IdPurchaseRequest',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "left",
            hidden: userAuth?.IdRol === 1
        },
        {
            // FechaPermiso4
            field: 'Date',
            header: 'Date',
            className: "colum-width-medium",
            body: (rowData) => (rowData.Date),
            align: 'center',
            Format: 'DateTime'
        },
        {
            // ESTADO
            field: 'Estado',
            header: 'Estado',
            className: "colum-width-medium",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
            Format: 'Estado'
        },
        {
            // PurchaseRequest
            field: 'PurchaseRequest',
            header: 'No. Requisa',
            className: "colum-width-medium",
            body: (rowData) => (rowData.PurchaseRequest),
            Format: 'Modal',
            align: 'center',
            Sumary: 'count',
        },
        {
            // Area
            field: 'Area',
            header: 'Área',
            className: "colum-width-large",
            body: (rowData) => (rowData.Area),
        },
        {
            // SolicitaN
            field: 'SolicitaN',
            header: 'Solicita',
            className: "colum-width-large",
            body: (rowData) => (rowData.SolicitaN),
        },
        {
            // Proveedor
            field: 'Proveedor',
            header: 'Proveedor',
            className: "colum-width-large",
            body: (rowData) => (rowData.Proveedor),
        },
        {
            // UserCreate
            field: 'UserCreate',
            header: 'Usuario',
            className: "colum-width-large",
            body: (rowData) => (rowData.UserCreate),
        },
        {
            // Comment
            field: 'Comment',
            header: 'Comentario',
            className: "colum-width-Xlarge",
            body: (rowData) => (rowData.Comment),
        },
    ]

    const table = {
        Columns: columns,
        Data: listadoRequisas,
        fileName: "RequisasCompras" + (new Date()).toDateString(),
        loading: loading,
        clases: "tablaListados alturaListado60",
        showModal: e => showModal(e),
        key: 'IdPurcharesRequest',
        Estados: estados
    }




    // Funciones para asignar los valores de las variables de estado.
    // const obtenerEstados = async () => {
    //     const tempo = await getStatus();
    //     let estadoNombre = []
    //     tempo.forEach((estado) => {
    //         estadoNombre.push(estado.StatusName)
    //     })
    //     setEstados(estadoNombre);
    // }

    const onHide = () => {
        setRequisaDialog(false);
        setPurchaseShow(null);
    }


    const showModal = (PurchaseRequest) => {
        console.log({PurchaseRequest});
        setPurchaseShow(PurchaseRequest);
        setRequisaDialog(true);
    }
    // Fecha

    // useEffect(() => {
    //     obtenerEstados();
    // }, []);

    return (
        <div >
            <Dialog visible={purchaseShow} onHide={onHide} maximized >
            <RequisicionCompraModal idRequisa={purchaseShow}/>
            </Dialog>
            <div style={{ height: '73vh' }}>
                <AgGrid table={table} />
            </div>

        </div>
    )
}

export default ListadoRequisaTab;

